/** No direct listener does not rule out a delegated dropdown/menu handler. */
export function autoReviewNeedsVerification(finding) {
    return finding.confidence === 'needs-verification'
        || (finding.checkId === 'dead-link' && finding.evidence?.kind !== 'interaction');
}
export const AUTO_REVIEW_VERIFICATION_NOTE = 'Needs verification: click this control on the original page and check its behavior. This observation does not lower the review score.';
/** Shared by scans from the extension, review pages and scheduled execution. */
export function retainAutoReviewConfidence(finding) {
    if (!autoReviewNeedsVerification(finding))
        return finding;
    return { ...finding, confidence: 'needs-verification', severity: 'low',
        aiReview: finding.aiReview?.verdict === 'real'
            ? { verdict: 'cannot-verify', evidence: 'A screenshot cannot establish whether a delegated click handler works. Test this control on the original page.' }
            : finding.aiReview };
}
/** The one issue text every Auto Review creation path writes: the extension,
 * team review, MCP, scheduled runs and saved email runs (Emily, 2026-10-24).
 * The finding's own description, with the verification note first when it applies. */
export function autoReviewIssueDescription(finding) {
    const description = finding.description?.trim() || 'Auto Review finding.';
    return autoReviewNeedsVerification(finding) && !description.includes(AUTO_REVIEW_VERIFICATION_NOTE)
        ? `${AUTO_REVIEW_VERIFICATION_NOTE}\n\n${description}` : description;
}
//# sourceMappingURL=confidence.js.map